module.exports = "<app-header class=\"mat-elevation-z6\"></app-header>\r\n<router-outlet></router-outlet>"